import React from 'react';
import SolutionInstallmentExaminationPaymentCompleteContainer from 'containers/SolutionInstallmentExaminationPaymentCompleteContainer/SolutionInstallmentExaminationPaymentCompleteContainer';

export default function SolutionInstallmentExaminationPaymentCompletePage() {
    return (
        <SolutionInstallmentExaminationPaymentCompleteContainer />
    )
}
